{
  "alert": "Figyelmeztetés",
  "dismiss": "Elutasítás"
}
